/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Mvp_Sprint_TaglineInputs */

const en_svc_mvp_sprint_tagline = /** @type {(inputs: Svc_Mvp_Sprint_TaglineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Idea to launched product in 2 to 4 weeks.`)
};

const ar_svc_mvp_sprint_tagline = /** @type {(inputs: Svc_Mvp_Sprint_TaglineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`من الفكرة إلى منتج مُطلَق خلال 2 إلى 4 أسابيع.`)
};

const bn_svc_mvp_sprint_tagline = /** @type {(inputs: Svc_Mvp_Sprint_TaglineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`২ থেকে ৪ সপ্তাহে আইডিয়া থেকে লঞ্চ করা প্রোডাক্ট।`)
};

const de_svc_mvp_sprint_tagline = /** @type {(inputs: Svc_Mvp_Sprint_TaglineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Von der Idee zum gelaunchten Produkt in 2 bis 4 Wochen.`)
};

const es_svc_mvp_sprint_tagline = /** @type {(inputs: Svc_Mvp_Sprint_TaglineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`De la idea al producto lanzado en 2 a 4 semanas.`)
};

const fr_svc_mvp_sprint_tagline = /** @type {(inputs: Svc_Mvp_Sprint_TaglineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`De l'idée au produit lancé en 2 à 4 semaines.`)
};

const pt_svc_mvp_sprint_tagline = /** @type {(inputs: Svc_Mvp_Sprint_TaglineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Da ideia ao produto lançado em 2 a 4 semanas.`)
};

const zh_svc_mvp_sprint_tagline = /** @type {(inputs: Svc_Mvp_Sprint_TaglineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`2 到 4 周，从想法到上线产品。`)
};

const tr_svc_mvp_sprint_tagline = /** @type {(inputs: Svc_Mvp_Sprint_TaglineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`2 ila 4 haftada fikirden yayındaki ürüne.`)
};

const ru_svc_mvp_sprint_tagline = /** @type {(inputs: Svc_Mvp_Sprint_TaglineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`От идеи до запущенного продукта за 2–4 недели.`)
};

const pl_svc_mvp_sprint_tagline = /** @type {(inputs: Svc_Mvp_Sprint_TaglineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Od pomysłu do wypuszczonego produktu w 2–4 tygodnie.`)
};

/**
* | output |
* | --- |
* | "Idea to launched product in 2 to 4 weeks." |
*
* @param {Svc_Mvp_Sprint_TaglineInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
const svc_mvp_sprint_tagline = /** @type {((inputs?: Svc_Mvp_Sprint_TaglineInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Mvp_Sprint_TaglineInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svc_mvp_sprint_tagline(inputs)
	if (locale === "bn") return bn_svc_mvp_sprint_tagline(inputs)
	if (locale === "de") return de_svc_mvp_sprint_tagline(inputs)
	if (locale === "es") return es_svc_mvp_sprint_tagline(inputs)
	if (locale === "fr") return fr_svc_mvp_sprint_tagline(inputs)
	if (locale === "pt") return pt_svc_mvp_sprint_tagline(inputs)
	if (locale === "zh") return zh_svc_mvp_sprint_tagline(inputs)
	if (locale === "tr") return tr_svc_mvp_sprint_tagline(inputs)
	if (locale === "ru") return ru_svc_mvp_sprint_tagline(inputs)
	if (locale === "pl") return pl_svc_mvp_sprint_tagline(inputs)
	return en_svc_mvp_sprint_tagline(inputs)
});
export { svc_mvp_sprint_tagline as "svc_mvp-sprint_tagline" }